import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import "./style.css";

const HomeBanner = (props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="homeBannerSection">
      <Swiper
        slidesPerView={1}
        spaceBetween={15}
        navigation={windowWidth > 992 ? true : false}
        loop={true}
        speed={500}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay]}
      >
        {props?.data?.length !== 0 &&
          props?.data?.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <div className="item">
                  <img src={item?.images}  width="100%" />
                </div>
              </SwiperSlide>
            );
          })}
      </Swiper>

      <div className="custom-shape-divider-bottom-1752001759">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
      </div>
    </div>
  );
};

export default HomeBanner;
